"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _attachment = _interopRequireDefault(require("../../../attachment"));
var _bundleContext = require("../../../context/bundle-context");
function BundleToggleRow({
  selector
}) {
  const {
    bundleState,
    toggleBundle
  } = (0, _bundleContext.useBundleContext)();
  const {
    video,
    image,
    ...rest
  } = selector; // eslint-disable-line no-unused-vars

  if (!selector) {
    return null;
  }
  const handleAttachmentChange = newState => {
    toggleBundle(selector.id, newState);
  };
  const videoSettings = {
    ...video,
    videoUrlLaptop: video?.videoUrlLaptop || 'https://img1.wsimg.com/cdnassets/asset/82ac2da4-f9c4-4f7a-b460-d14a6d0343fe/mp4/preCheck-domainBundle.mp4',
    videoUrlLaptopWebm: video?.videoUrlLaptopWebm || 'https://img1.wsimg.com/cdnassets/m/5cbb36e119b448c8/original/preCheck-domainBundle.webm'
  };
  return /*#__PURE__*/_react.default.createElement(_attachment.default, (0, _extends2.default)({
    "data-cy": "bundle-toggle-row"
  }, rest, {
    video: videoSettings,
    checked: bundleState.isActive,
    onChange: handleAttachmentChange,
    inputName: selector.instancePath
  }));
}
var _default = exports.default = BundleToggleRow;
BundleToggleRow.propTypes = {
  selector: _propTypes.default.object.isRequired
};